<script>
import formatDate from '@utils/format-date'
import formatCurrency from "@utils/format-currency";
import  { formatOrder } from "@utils/format-order";
import { merchantComputed } from "@store/helpers";
import { orderIsCanPay } from "@utils/ipetbooking-order";
import formatPrice from "@utils/format-price";
// import { conditionList } from "@utils/is-condition";

const statusColor = {
  pending: 'danger',
  processing: 'warning',
  'shipment-proc': 'complete',
  'shipment-return': 'gray-1',
  completed: 'complete',
  cancelled: 'gray-1',
  refunded: 'danger',
}

export default {
  props: {
    orderList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      statusColor,
    }
  },
  computed: {
    ...merchantComputed,
    formatOrderList() {
      return this.orderList.map(item => {
        return {
          storeList: [],
          head: [],
          body: [
            {
              title: '',
              titleClass: '',
              text: `#${item.orderNo}`,
              textClass: '',
              class: '',
            },
            {
              title: '訂單狀態',
              titleClass: '',
              text: `<span class="text-${statusColor[item.status.alias]}">${item.status.title}</span>`,
              textClass: '',
              class: '',
            },
            {
              title: '總計',
              titleClass: '',
              text: formatCurrency(item.total),
              textClass: '',
              class: '',
            },
            {
              title: '訂單成立日期',
              titleClass: '',
              text: formatDate(item.created, 'yyyy/MM/dd'),
              textClass: '',
              class: '',
            },
          ],
          addOrder: [],
          foot: [
            {
              type: 'button',
              text: '取消',
              class: 'flex-grow-1',
              buttonClass: 'isStyleDark isOutline3 isRadius isFull',
              condition: () => item.canCancel,
              onClick: () => {
                this.onClickCancelOrder(item)
              },
            },
            {
              type: 'button',
              text: '前往付款',
              class: 'flex-grow-1',
              buttonClass: 'isStyleSecondary isRadius isFull',
              condition: () => !!item.payUrl,
              onClick: () => {
                window.location.href = item.payUrl
              },
            },
            {
              type: 'button',
              text: '查看',
              class: 'flex-grow-1',
              buttonClass: 'isStyleDark isOutline3 isRadius isFull',
              onClick: () => {
                this.goToMemberOrderItem(item);
              },
            },
          ]
        }
      })
    }
  },
  methods: {
    formatOrder,
    orderIsCanPay,
    formatPrice,
    formatDate,
    formatCurrency,
    goToMemberOrderItem(item) {
      this.$router.push({
        name: 'shop-member-shopping-item',
        params: {
          orderId: item.id
        }
      })
    },
    async onClickCancelOrder({ id }) {
      await this.$confirm('您確定要取消訂單嗎？', '取消訂單', {
        customClass: 'isStyleBase isReverse',
        confirmButtonText: '確認取消',
        cancelButtonText: '取消',
      })
      this.tryToCancelOrder(id)
    },
    async tryToCancelOrder(id) {
      await this.$store.dispatch('wordpress/cancelOrderItem', id)
      this.$emit('update')
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.orderListSectionList">
    <BaseOrderListJtails
      :loading="$isLoading('fetchOrderList') || $isLoading('cancelOrderItem')"
      loading-text="取得我的購物中..."
      :order-list="formatOrderList"
      class="d-xl-none"
    />
    <el-table
      v-loading="$isLoading('fetchOrderList') || $isLoading('cancelOrderItem')"
      element-loading-text="取得我的購物中..."
      :data="orderList"
      class="isStyleBase isRowPointer mb-5 d-none d-xl-block"
      :class="$style.orderList"
    >
      <el-table-column v-slot="{ row }" label="訂單編號">
        <span class="ls-sm">＃{{ row.orderNo }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="狀態" align="center">
        <div
          class="fw-medium"
          :class="`text-${statusColor[row.status.alias]}`"
        >
          {{ row.status.title }}
        </div>
        <div>
          <BaseButton
            v-if="!!row.payUrl"
            class="isStyleSecondary isRadius isSmall mt-2"
            :href="row.payUrl"
          >
            前往付款
          </BaseButton>
        </div>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="總計" align="left">
        <span class="font-number">NT$ {{ formatCurrency(row.total) }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="訂單成立日期">
        <span class="font-number">{{ formatDate(row.created, 'yyyy/MM/dd') }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="取消" width="80" align="center">
        <BaseButton
          v-if="row.canCancel"
          class="isStyleSecondary isText"
          @click="onClickCancelOrder(row)"
        >
          <i class="fal fa-trash-alt" style="font-size: 1.25rem;"></i>
        </BaseButton>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="查看" width="80" align="center">
        <BaseButton
          event
          class="isStyleSecondary isText"
          @click="goToMemberOrderItem(row)"
        >
          <i class="fontello fontello-view fa-2x"></i>
        </BaseButton>
      </el-table-column>
    </el-table>
    <BasePre>orderList: {{ orderList }}</BasePre>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.orderListSectionList {
  min-height: 532px;

  :global {
    .orderListSectionList {
      &__dropdown {
        width: 100%;
        font-size: 1rem;
      }
    }
  }
}

.orderList {
  :global {
    .orderList {
      &__title {
        font-weight: 500;
      }

      &__date, &__meta {
        font-size: 0.75rem;
        color: $color-gray-2;
        letter-spacing: 0.1em;
      }
    }

    // stylelint-disable selector-class-pattern
    .el-table__expand-column {
      padding: 0;

      > .cell {
        padding: 0;

        > .el-table__expand-icon {
          height: 95px;
        }
      }
    }

    // stylelint-enable selector-class-pattern
  }
}
</style>
